/**
 * Shared action icons — Feather/Lucide-style line glyphs (24×24, stroke 1.7,
 * currentColor) matching the sidebar icon set. Used so the per-row edit
 * affordance is one consistent, properly-oriented pencil everywhere instead of
 * a platform-dependent Unicode glyph.
 */

/** Edit pencil — diagonal, tip at lower-left (the Lucide "pencil"). */
export function EditIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
      <path d="m15 5 4 4" />
    </svg>
  );
}

/** Key — the Lucide "key-round"; the admin password-reset affordance. */
export function KeyIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z" />
      <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
    </svg>
  );
}

/** Spreadsheet with download arrow — the CR portfolio export affordance. */
export function SpreadsheetExportIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* Sheet outline */}
      <rect x="3" y="3" width="12" height="18" rx="2" />
      {/* Column line */}
      <path d="M9 3v18" />
      {/* Row lines */}
      <path d="M3 8h12" />
      <path d="M3 13h12" />
      {/* Download arrow outside sheet */}
      <path d="M17 15l3 3 3-3" />
      <path d="M20 18v-6" />
    </svg>
  );
}

/** Trash can — the Lucide "trash-2"; the destructive (permanent) delete affordance. */
export function TrashIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 6h18" />
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <line x1="10" y1="11" x2="10" y2="17" />
      <line x1="14" y1="11" x2="14" y2="17" />
    </svg>
  );
}
